// 発行ページ (mock UX 準拠 / 実API)。
//   /issuance/            発行一覧 (Paper+Table・ID 行リンクで詳細へ)
//   /issuance/new/        新規発行 (QR枚数 + 備考)
//   /issuance/:id/        発行詳細 (InfoList + QR印刷)
//   /issuance/:id/edit/   発行編集 (備考のみ。発行枚数は不変)
// 発行は当面オンライン限定 (作成/編集は実API、IDB merge 経路は未整備のため offline 不可)。

import { Navigate, Route, Routes } from "react-router-dom";
import { PageContext } from "../PageContext";
import { IssuanceListPage } from "./IssuanceListPage";
import { IssuanceNewPage } from "./IssuanceNewPage";
import { IssuanceDetailPage } from "./IssuanceDetailPage";
import { IssuanceEditPage } from "./IssuanceEditPage";

export default function IssuancePage({ pageContext }: { pageContext: PageContext }) {
  return (
    <Routes>
      <Route index element={<IssuanceListPage pageContext={pageContext} />} />
      <Route path="new/" element={<IssuanceNewPage pageContext={pageContext} />} />
      <Route path=":id/" element={<IssuanceDetailPage pageContext={pageContext} />} />
      <Route path=":id/edit/" element={<IssuanceEditPage pageContext={pageContext} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
